import { useState, useEffect } from 'react'

export function useCurrency() {
  const [symbol, setSymbol] = useState('$')

  useEffect(() => {
    const locale = navigator.language || 'es-AR'
    const lowerLocale = locale.toLowerCase()

    if (lowerLocale.startsWith('pt')) {
      setSymbol('R$')
    } else if (lowerLocale === 'en-gb') {
      setSymbol('£')
    } else if (
      ['fr', 'de', 'it', 'nl', 'es-es'].some((l) => lowerLocale.startsWith(l))
    ) {
      setSymbol('€')
    } else {
      setSymbol('$') // Default for es-AR, en-US, etc.
    }
  }, [])

  return symbol
}
